import { Box, Button, Typography } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';
import { Plus } from '../../../../icons/plus';
import { DialogStyle } from './style';

type NewTalentDialogErrorProps = {
  message: string,
  Icon: typeof SvgIcon,
  onCreateTalentManually: () => void,
}
  
export default function NewTalentDialogContent({
  message,
  Icon,
  onCreateTalentManually,
}:NewTalentDialogErrorProps): JSX.Element {
  const { t: translate } = useTranslation();
  
  return (
    <Box style={ DialogStyle.box }>
      <Typography
        style={ DialogStyle.errorMessage.style }
        sx={ DialogStyle.errorMessage.sx }
      >
        <Icon style={  DialogStyle.brokenImage } />
        { message }
      </Typography>
      <Button
        startIcon={ <Plus /> }
        onClick={ onCreateTalentManually }
      >
        {translate(STRING_KEYS.CREATE_TALENT_MANUALLY)}
      </Button>
    </Box>
  );
}
